<template>
  <div class="file-viewer-list-wrapper" :class="{ maximized }">
    <div v-show="maximized" class="list-header">
      <slot name="header"></slot>
    </div>
    <div class="list-content">
      <div class="content-header">
        <p v-if="viewTypeFileLists.length > 0" class="title">
          {{ title }}
        </p>
        <p v-if="subtitle" class="subtitle">
          {{ subtitle }}
        </p>
      </div>
      <div class="content-body">
        <swiper
          ref="listSwiper"
          :options="listSwiperOptions"
          class="list-swiper"
        >
          <swiper-slide
            v-for="(file, index) in sortedFileList"
            :key="file.viewType + file.id"
          >
            <div
              class="file-item"
              :class="{ active: currentItem.id === file.id }"
              @click="changeItem(index)"
            >
              <div class="name">
                <i
                  v-if="currentItem.id === file.id"
                  class="iconfont icon-kaishibofang"
                ></i>
                <span class="text">
                  {{
                    (file.viewType === 'article' ? file.title : file.name)
                      | filename
                  }}
                </span>
              </div>
              <div class="attrs">
                <span
                  v-if="file.authority - 0 === 1"
                  class="internal-subscript"
                >
                  内部文件
                </span>
                <span class="file-type">{{
                  file.viewType === 'article'
                    ? '文章'
                    : getFileTypeDisplayName(file)
                }}</span>
                <span v-if="file.viewType !== 'article'" class="file-size">
                  文件：{{ file.size }}
                </span>
              </div>
            </div>
          </swiper-slide>
          <div slot="scrollbar" class="swiper-scrollbar"></div>
        </swiper>
      </div>
    </div>
    <div v-show="maximized" class="list-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  filters: {
    filename(value) {
      return value.split('.').slice(0, 1).join('.')
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  props: {
    // 传递进来的排序之后的文件列表
    sortedFileList: {
      type: Array,
      default: () => []
    },
    // 文件列表标题
    title: {
      type: String,
      default: '案例资料'
    },
    // 文件列表副标题
    subtitle: {
      type: String,
      default: ''
    },
    // 是否允许全部下载
    // 全部下载的控制放在文件组件层面，单个文件下载的控制放在单个文件内
    allDownloadable: Boolean,
    // 显示对内标签,针对于文件自己本身
    showAuthority: Boolean,
    maximized: Boolean,
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentItem: {},
      listSwiperOptions: {
        direction: 'vertical',
        freeMode: true,
        slidesPerView: 'auto',
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true
        },
        mousewheel: true,
        spaceBetween: 8
      }
    }
  },
  computed: {
    viewTypeFileLists() {
      return this.sortedFileList.filter(item => item.viewType === 'file')
    },
    downloadAll() {
      return this.allDownloadable && this.viewTypeFileLists.length > 1
    }
  },
  created() {
    if (this.sortedFileList.length > 0) {
      this.currentItem = this.sortedFileList[this.current]
    }
  },
  methods: {
    getFileType(file = {}) {
      let type = file.postfix.toLocaleLowerCase()
      if (['jpg', 'jpeg', 'bmp', 'png', 'gif'].includes(type)) {
        type = 'img'
      }
      if (['zip', 'rar'].some(item => file.name.endsWith(item))) {
        type = 'zip'
      }
      return type
    },
    getFileTypeDisplayName(file) {
      const type = this.getFileType(file)
      let typeName = ''
      switch (type) {
        case 'img':
          typeName = '图片'
          break
        case 'mp4':
          typeName = '视频'
          break
        case 'pdf':
          typeName = 'PDF'
          break
        case 'ppt':
          typeName = 'PPT'
          break
        case 'zip':
          typeName = '压缩包'
          break
        default:
          typeName = '未知'
          break
      }
      return typeName
    },
    changeItem(index) {
      this.currentItem = this.sortedFileList[index]
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.file-viewer-list-wrapper {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  .list-content {
    padding: 14px 0 0 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .content-header {
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .download-pack {
      background-color: rgba(255, 255, 255, 0.05);
      width: 102px;
      height: 32px;
      text-align: center;
      color: #ffffff;
      font-size: 14px;
      line-height: 32px;
      cursor: pointer;
      border-radius: 16px;
      i {
        margin-right: 4px;
      }
      &:hover {
        background-color: #3352fe;
        color: #ffffff;
      }
    }
    .subtitle {
      margin-top: 8px;
      font-size: 14px;
      color: #727272;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .content-body {
    flex: 1;
    position: relative;
  }
  .swiper-container {
    height: 100%;
    position: absolute;
    left: 0;
    top: 8px;
    width: 100%;
  }
  .swiper-slide {
    width: auto;
    height: auto;
    overflow: hidden;
  }
  .file-item {
    padding: 8px 16px;
    cursor: pointer;
    border-radius: 3px;
    box-sizing: border-box;
    .name {
      font-size: 14px;
      line-height: normal;
      position: relative;
      .text {
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .internal-subscript {
      font-size: 12px;
      display: inline-block;
      padding: 0 8px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 3px;
      background-color: #f8653f;
      color: #ffffff;
      margin-right: 4px;
    }
    .file-type {
      display: inline-block;
      background-color: #363636;
      border-radius: 3px;
      font-size: 12px;
      padding: 0 8px;
      height: 20px;
      line-height: 20px;
      text-align: center;
    }
    .file-size {
      display: inline-block;
      padding: 0 8px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #727272;
    }
    .attrs {
      overflow: hidden;
    }
    &:last-child {
      margin-bottom: 0;
    }
    &.active,
    &:hover {
      .name {
        i {
          position: absolute;
          left: -20px;
          top: 2px;
          font-size: 14px;
        }
      }
      .file-size {
        color: #ffffff;
      }
      .file-type {
        background-color: rgba(0, 0, 0, 0.25);
      }
    }
    &:hover {
      background-color: rgba(51, 82, 254, 0.65);
    }
    &.active {
      background-color: #3352fe;
      padding-left: 36px;
    }
  }
  .list-header {
    color: #363636;
    margin-bottom: 20px;
  }
  .list-footer {
    color: #363636;
  }
  &.maximized {
    background-color: #ffffff;
    .content-header {
      margin-bottom: 14px;
      padding-right: 24px;
      .title {
        color: #363636;
        padding-left: 7px;
        &:before {
          content: '';
          left: -8px;
          top: 50%;
          margin-top: -8px;
          width: 3px;
          height: 16px;
          background-color: #3352fe;
          position: absolute;
          border-radius: 3px;
        }
        &:after {
          content: '';
          position: absolute;
          left: -8px;
          right: -8px;
          bottom: -14px;
          height: 1px;
          background-color: #efeff3;
        }
      }
      .subtitle {
        display: none;
      }
      .download-pack {
        color: #363636;
        background-color: #f4f5f7;
        &:hover {
          background-color: #3352fe;
          color: #ffffff;
        }
      }
    }
    .content-body {
      margin-left: -8px;
    }
    .file-item {
      &,
      &:hover {
        background-color: transparent;
        .name {
          color: #363636;
        }
        .file-type {
          background-color: #f4f5f7;
          color: #727272;
        }
        .file-size {
          color: #727272;
        }
      }
      &.active {
        background-color: transparent;
        padding-left: 20px;
        .name {
          color: #3352fe;
        }
        .file-type {
          background-color: #3352fe;
          color: #ffffff;
        }
        .file-size {
          color: #3352fe;
        }
      }
    }
  }
}
</style>
